/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSentMailsResponseItems
 */
export interface GetSentMailsResponseItems {
    /**
     * 
     * @type {number}
     * @memberof GetSentMailsResponseItems
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof GetSentMailsResponseItems
     */
    aktid: number;
    /**
     * 
     * @type {string}
     * @memberof GetSentMailsResponseItems
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof GetSentMailsResponseItems
     */
    subject: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSentMailsResponseItems
     */
    isBold: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSentMailsResponseItems
     */
    icon: string;
    /**
     * 
     * @type {string}
     * @memberof GetSentMailsResponseItems
     */
    resp: string;
    /**
     * 
     * @type {number}
     * @memberof GetSentMailsResponseItems
     */
    priority: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetSentMailsResponseItems
     */
    hasattachment: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSentMailsResponseItems
     */
    aktname: string;
    /**
     * 
     * @type {number}
     * @memberof GetSentMailsResponseItems
     */
    akttype: number;
    /**
     * 
     * @type {string}
     * @memberof GetSentMailsResponseItems
     */
    sender: string;
    /**
     * 
     * @type {string}
     * @memberof GetSentMailsResponseItems
     */
    summary: string;
    /**
     * 
     * @type {number}
     * @memberof GetSentMailsResponseItems
     */
    todotype: number;
}

export function GetSentMailsResponseItemsFromJSON(json: any): GetSentMailsResponseItems {
    return GetSentMailsResponseItemsFromJSONTyped(json, false);
}

export function GetSentMailsResponseItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSentMailsResponseItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'aktid': json['aktid'],
        'date': json['date'],
        'subject': json['subject'],
        'isBold': json['isBold'],
        'icon': json['icon'],
        'resp': json['resp'],
        'priority': json['priority'],
        'hasattachment': json['hasattachment'],
        'aktname': json['aktname'],
        'akttype': json['akttype'],
        'sender': json['sender'],
        'summary': json['summary'],
        'todotype': json['todotype'],
    };
}

export function GetSentMailsResponseItemsToJSON(value?: GetSentMailsResponseItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'aktid': value.aktid,
        'date': value.date,
        'subject': value.subject,
        'isBold': value.isBold,
        'icon': value.icon,
        'resp': value.resp,
        'priority': value.priority,
        'hasattachment': value.hasattachment,
        'aktname': value.aktname,
        'akttype': value.akttype,
        'sender': value.sender,
        'summary': value.summary,
        'todotype': value.todotype,
    };
}


